import useApi from "./useApi";

const useSynchronization = () => {
  const { postData } = useApi();

  const resetSyncItems = async (models) => {
    if (!Array.isArray(models) || models.length === 0) return;

    const results = await postData({
      entityName: "Synchronization",
      action: "resetModels",
      data: {
        models,
        filter: {},
      },
    });

    return results;
  };

  return {
    resetSyncItems,
  };
};

export default useSynchronization;
